import React from 'react';

import Icon from './Icon/Icon';

const CardProcessor = ({ children, style = {}, size = 44, iconSize = 20 }) => {
  switch (children) {
    case 'MASTERCARD':
    case 'MC':
      return <Icon icon="cards-visuals-mastercard" size={size} />;
    case 'VISA':
      return <Icon icon="cards-visuals-visa" size={size} />;
    case 'DISCOVER':
      return <Icon icon="cards-visuals-discover" size={size} />;
    case 'AMEX':
      return <Icon icon="cards-visuals-amex" size={size} />;
    case 'Debit MasterCard':
      return <Icon icon="cards-visuals-mastercard" size={size} />;
    case 'Diners':
      return <Icon icon="cards-visuals-diners" size={size} />;
    case 'Discover':
      return <Icon icon="cards-visuals-discover" size={size} />;
    case 'JCB':
      return <Icon icon="cards-visuals-jcb" size={size} />;
    case 'Maestro':
      return <Icon icon="cards-visuals-maestro" size={size} />;
    case 'MasterCard':
      return <Icon icon="cards-visuals-mastercard" size={size} />;
    case 'Visa Credit':
      return <Icon icon="cards-visuals-visa" size={size} />;
    case 'Visa Debit':
      return <Icon icon="cards-visuals-visa" size={size} />;
    case 'Visa Electron':
      return <Icon icon="cards-visuals-visa" size={size} />;
    case 'card':
      return <Icon icon="credit-card-mono" size={iconSize} />;
    case 'ACH':
      return (
        <div className="flex w-11 items-center justify-center rounded-md border border-solid border-neutral-200 p-1">
          <Icon icon="building-mono" size={iconSize} />
        </div>
      );
    default:
      return <div style={style}>{children}</div>;
  }
};

export default CardProcessor;
